import { render, staticRenderFns } from "./KimHyunwoong.vue?vue&type=template&id=4a50db0b&scoped=true"
import script from "./KimHyunwoong.vue?vue&type=script&lang=js"
export * from "./KimHyunwoong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50db0b",
  null
  
)

export default component.exports